import * as React from 'react';
import { useInvalidSection } from '../metroline/invalid-section';
import { useExternalUrlConfiguration, getExternalUrlRoute } from '../metroline/external-url-configuration';
import { ExternalUrlItem } from '../types-store';
import { ExternalUrlFormProps } from '../types';
import { ExternalUrlFormRenderer } from './external-url-form-renderer';

export const ExternalUrlFormSections: React.FC<ExternalUrlFormProps> = ({
  actionType, formState, mainLanguage, options, section, locale, translation,
  showTranslations, translationAdminAccess, shouldPrompt, 
  changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
  saveExternalUrl, deleteExternalUrl, updateValidation, resetValidation, displayError,
  updateItem, loadOptions, switchTranslationsToggle, updateExcludedFields
}) => {

  const scrollViewUrl = getExternalUrlRoute(actionType, formState.externalUrlItem?.id);

  const configuration = useExternalUrlConfiguration(
    actionType,
    formState.externalUrlItem?.id,
    formState.validation
  );

  const [invalidSection, updateInvalidSection] = useInvalidSection(configuration, formState.validation);

  const onSaveExternalUrl = (item: ExternalUrlItem) => {
    updateInvalidSection(undefined);
    saveExternalUrl(item);
  };

  return <ExternalUrlFormRenderer
    showTranslations={showTranslations}
    switchTranslationsToggle={switchTranslationsToggle}
    actionType={actionType}
    formState={formState}
    shouldPrompt={shouldPrompt}
    mainLanguage={mainLanguage}
    saveExternalUrl={onSaveExternalUrl}
    deleteExternalUrl={deleteExternalUrl}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    changeLongDescription={changeLongDescription}
    copyLongDescriptionToAll={copyLongDescriptionToAll}
    options={options}
    loadOptions={loadOptions}
    updateExcludedFields={updateExcludedFields}
    updateValidation={updateValidation}
    resetValidation={resetValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.external_urls}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    translationAdminAccess={translationAdminAccess} />;
};
